"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, ErrorState } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsErrorBoundary() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Error Boundary
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Catches JavaScript errors in child components and displays a fallback UI.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/error-boundary" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Error State</CardTitle>
              <CardDescription>The error display component</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <ErrorState
            title="Something went wrong"
            description="We couldn't load this content. Please try again."
            onRetry={() => console.log("Retry clicked")}
          />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">title</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Error title</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">description</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Error description</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">onRetry</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">() =&gt; void</td>
                <td className="py-2 text-muted-foreground">Retry callback function</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
